import { SideBarButton } from '../../nav-list/recursive-sidebar/class/sidebar';
import { PreConfigButton1 } from '../../nav-list/recursive-sidebar/configuration/preconfig';
import { EliteAdminRoutes } from './elite-admin-routes';
import { PowerDeparmentsRoutes } from './power-deparments-routes';
import { PowerLabRoutes } from './powerlab-routes';
import {
  NetsuiteGeneralRoutes,
  NetsuiteSalesOrderRoutes,
  NetsuiteWorkOrderRoutes,
} from './netsuite-routes';

export const ReportesNavRoutes: SideBarButton = {
  data: {
    name: 'Reportes',
  },
  options: PreConfigButton1,
  icon: 'summarize',
  butons: [
    NetsuiteGeneralRoutes,
    NetsuiteSalesOrderRoutes,
    NetsuiteWorkOrderRoutes,
    EliteAdminRoutes,
    PowerDeparmentsRoutes,
    PowerLabRoutes,
  ],
};
